import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from '../redux/store';
import { getAllUserInstitutionIds, getInstitutionId, getIsLoggedIn } from '../redux/slices/account';
import { getUrlOnLogin, getUserNavigationArray } from '../redux/slices/navigation';
import { getPostLoginPath } from './getPostLoginPath';

GuestGuard.propTypes = { children: PropTypes.node };

export default function GuestGuard({ children }) {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const userNavigations = useSelector(getUserNavigationArray);
  const allUserInstitutionIds = useSelector(getAllUserInstitutionIds);
  const institutionId = useSelector(getInstitutionId);
  const urlOnLogin = useSelector(getUrlOnLogin);
  if (isLoggedIn) {
    return <Navigate replace to={getPostLoginPath({
      userNavigations, allUserInstitutionIds, institutionId, urlOnLogin,
    })} />;
  }
  return <>{children}</>;
}
